import { render, staticRenderFns } from "./DeliveryAddressSummary.vue?vue&type=template&id=4003c924&scoped=true&"
import script from "./DeliveryAddressSummary.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressSummary.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressSummary.vue?vue&type=style&index=0&id=4003c924&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003c924",
  null
  
)

export default component.exports